import { PencilIcon, PlusIcon, TrashIcon } from '@heroicons/react/24/outline';
import { ActionIcon, Button, Table, Title } from '@mantine/core';
import cn from 'clsx';
import { useNavigate } from 'react-router-dom';

import { DeleteAuthorModal } from '@/features/delete-author-modal';
import { RouteList } from '@/shared/constants';
import { useProjectPath } from '@/shared/projects/project-path';
import { useAuthorsStore } from '@/shared/stores/authors.store';

import { useGetAuthors } from '../model/authors-page.cases';
import styles from './authors-page.module.scss';

export const AuthorsPage = () => {
  const navigate = useNavigate();
  const withProject = useProjectPath();
  const getAuthorsQuery = useGetAuthors();
  const setDeletableAuthor = useAuthorsStore(
    (state) => state.setDeletableAuthors,
  );

  return (
    <div className={styles.container}>
      <Title order={1} size={44} className={styles.title}>
        Авторы
      </Title>
      <div className={styles.header}>
        <Button
          size="lg"
          leftSection={<PlusIcon width={20} height={20} />}
          onClick={() => navigate(withProject(RouteList.CREATE_AUTHOR))}
        >
          Добавить автора
        </Button>
      </div>
      <DeleteAuthorModal />
      <Table.ScrollContainer minWidth="100%" className={styles.table}>
        <Table withTableBorder flex={1}>
          <Table.Thead>
            <Table.Tr>
              <Table.Th
                className={cn(styles.tableHeadCell, styles.authorHeadCell)}
              >
                Автор
              </Table.Th>
              <Table.Th className={styles.tableHeadCell}>Описание</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {getAuthorsQuery.data.authors.map((author) => (
              <Table.Tr key={author.id} className={styles.tableRow}>
                <Table.Td
                  width="50%"
                  className={styles.authorTitleCell}
                  onClick={() =>
                    navigate(
                      withProject(RouteList.AUTHOR_DETAILS(String(author.id))),
                    )
                  }
                >
                  {author.name}
                </Table.Td>
                <Table.Td width="40%">{author.description}</Table.Td>
                <Table.Td width="10%">
                  <div className={styles.actions}>
                    <ActionIcon
                      variant="subtle"
                      size="lg"
                      color="gray"
                      onClick={() =>
                        navigate(
                          withProject(RouteList.EDIT_AUTHOR(String(author.id))),
                        )
                      }
                    >
                      <PencilIcon width={24} height={24} />
                    </ActionIcon>
                    <ActionIcon
                      variant="subtle"
                      size="lg"
                      color="gray"
                      onClick={() =>
                        setDeletableAuthor({
                          id: author.id,
                          name: author.name,
                        })
                      }
                    >
                      <TrashIcon width={24} height={24} />
                    </ActionIcon>
                  </div>
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      </Table.ScrollContainer>
    </div>
  );
};
